//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import { removeSessionStorageQuery } from "@/utils/common";

export default {
  data() {
    return {
      menus: [],
      obj: {
        defaultActive: this.$route.meta.hidden
          ? this.$route.meta.targetPath
          : this.$route.path,
      },
      menuList: [],
    };
  },
  watch: {
    $route(to) {
      if (to.meta.hidden) {
        this.obj.defaultActive = to.meta.targetPath;
      } else {
        this.obj.defaultActive = this.$route.path;
      }
      let menuIndex = this.menuList.findIndex((item) => {
        return item.path == to.path;
      });
      if (menuIndex > -1) {
        this.menus = this.menuList[menuIndex].children;
      }
    },
    "$store.state.headMenuPath": {
      handler(val) {
        this.handleMenus(val);
      },
    },
    "$route.query.$businessType": {
      handler(val) {
        this.businessType = val ? val : "home";
      },
    },
  },
  created() {
    this.saveHeadMenuPath(this.$route.meta.headMenuPath);
    this.handleMenus(this.$store.state.headMenuPath);
    let { $businessType } = this.$route.query;
    this.businessType = $businessType ? $businessType : "home";
  },
  methods: {
    ...mapActions(["saveHeadMenuPath"]),
    handleMenus(headMenuPath) {
      let menuList = this.$router.options.routes.filter((item) => {
        return !item.meta.hidden;
      })[0].children;
      this.menuList = menuList;
      let headMenu = menuList.filter((item) => item.path == headMenuPath)[0];
      this.menus = headMenu.children;
    },

    onMenuSelect() {
      // 菜单改变时候 清除 缓存的 表格查询条件数据。
      removeSessionStorageQuery();
    },
  },
};
